import { render, staticRenderFns } from "./MealPlanDownloads.vue?vue&type=template&id=e981c5f6&scoped=true"
import script from "./MealPlanDownloads.vue?vue&type=script&lang=js"
export * from "./MealPlanDownloads.vue?vue&type=script&lang=js"
import style0 from "./MealPlanDownloads.vue?vue&type=style&index=0&id=e981c5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e981c5f6",
  null
  
)

export default component.exports